import { call, put } from 'redux-saga/effects';
import { getPropertyDeductionBalance } from '../services/api';
import {
  getPropertyDeductionBalanceError,
  getPropertyDeductionBalanceSuccess,
} from '../redux/actions';

export function* getPropertyDeductionsSaga() {
  const { isOk, error, data } = yield call(getPropertyDeductionBalance);
  if (isOk) {
    return yield put(getPropertyDeductionBalanceSuccess(data));
  }
  return yield put(getPropertyDeductionBalanceError(error));
}
